/**
 * Dynamic Social Proof Badge Numbers
 * Updates viewing and enrollment numbers randomly
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    viewingMin: 15,
    viewingMax: 45,
    enrollmentMin: 3,
    enrollmentMax: 12,
    storageKeyViewing: 'octa_viewing_count',
    storageKeyEnrollment: 'octa_enrollment_count',
    storageKeyTimestamp: 'octa_numbers_timestamp',
    updateIntervalWeeks: 1 // Update numbers every week
  };

  /**
   * Generate random number between min and max
   */
  function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  /**
   * Get current timestamp
   */
  function getCurrentTimestamp() {
    return new Date().getTime();
  }

  /**
   * Check if we should update the numbers (weekly check)
   */
  function shouldUpdateNumbers() {
    const storedTimestamp = localStorage.getItem(CONFIG.storageKeyTimestamp);
    
    if (!storedTimestamp) {
      return true; // First time, generate new numbers
    }

    const lastUpdate = parseInt(storedTimestamp, 10);
    const currentTime = getCurrentTimestamp();
    const weekInMs = 7 * 24 * 60 * 60 * 1000;
    
    return (currentTime - lastUpdate) >= weekInMs;
  }

  /**
   * Generate and store new random numbers
   */
  function generateNewNumbers() {
    const viewingCount = getRandomNumber(CONFIG.viewingMin, CONFIG.viewingMax);
    const enrollmentCount = getRandomNumber(CONFIG.enrollmentMin, CONFIG.enrollmentMax);
    
    localStorage.setItem(CONFIG.storageKeyViewing, viewingCount);
    localStorage.setItem(CONFIG.storageKeyEnrollment, enrollmentCount);
    localStorage.setItem(CONFIG.storageKeyTimestamp, getCurrentTimestamp());
    
    return {
      viewing: viewingCount,
      enrollment: enrollmentCount
    };
  }

  /**
   * Get stored numbers or generate new ones
   */
  function getNumbers() {
    if (shouldUpdateNumbers()) {
      return generateNewNumbers();
    }

    const storedViewing = parseInt(localStorage.getItem(CONFIG.storageKeyViewing), 10);
    const storedEnrollment = parseInt(localStorage.getItem(CONFIG.storageKeyEnrollment), 10);

    return {
      viewing: storedViewing || getRandomNumber(CONFIG.viewingMin, CONFIG.viewingMax),
      enrollment: storedEnrollment || getRandomNumber(CONFIG.enrollmentMin, CONFIG.enrollmentMax)
    };
  }

  /**
   * Update the social proof badge with dynamic numbers
   */
  function updateSocialProofBadge() {
    const numbers = getNumbers();
    
    // Find the social proof badge element
    const socialProofElement = document.querySelector('.octa-social-proof');
    
    if (socialProofElement) {
      const lines = socialProofElement.querySelectorAll('.octa-social-proof__lines p');
      
      if (lines.length >= 2) {
        // Update first line: "X people are viewing this course right now"
        lines[0].textContent = `${numbers.viewing} people are viewing this course right now`;
        
        // Update second line: "X enrolments this week"
        lines[1].textContent = `${numbers.enrollment} enrolments this week`;
      }
    }
  }

  /**
   * Initialize dynamic numbers on page load
   */
  function init() {
    // Update on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateSocialProofBadge);
    } else {
      updateSocialProofBadge();
    }

    // Also update when the section is rendered (for AJAX updates)
    document.addEventListener('shopify:section:load', updateSocialProofBadge);
  }

  // Start initialization
  init();
})();
